// extracted by mini-css-extract-plugin
module.exports = {"spinWrapper":"Overview_spinWrapper__290F7"};